import { Component, Inject, OnInit, PLATFORM_ID } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { CalculatorService } from '../../../providers/calculator.service';
import { IndicatorsService } from '../../../providers/indicators.service';
import { RequestLoaderService } from '../../../providers/request-loader.service';
import { ResultadoPopUpComponent } from '../resultado-pop-up/resultado-pop-up.component';
import { InvestmentsService } from '../../../providers/investments.service';
import { TituloCard } from '../../../model/titulo-card';
import { DatePipe, isPlatformBrowser, Location } from '@angular/common';
import * as Highcharts from 'highcharts';
import { Router } from '@angular/router';
import { Connector } from 'app/providers/connector';
import { SeoService } from 'app/providers/seo.service';
import { UserService } from 'app/providers/user.service';
import { HttpClient } from '@angular/common/http';
import { Constants } from 'app/providers/constants';
import { isDate } from 'rxjs/internal-compatibility';

@Component({
  selector: 'app-new-calculadoras-page',
  templateUrl: './calculadoras-main-page.component.html',
  styleUrls: ['./calculadoras-main-page.component.scss'],
  host: {
    '(window:resize)': 'onResize($event)'
  }
})
export class CalculadorasMainPageComponent implements OnInit {

  constructor(
    private spinner: RequestLoaderService,
    private calculatorService: CalculatorService,
    private indicatorsService: IndicatorsService,
    private investmentsService: InvestmentsService,
    private dialog: MatDialog,
    private datepipe: DatePipe,
    private location: Location,
    private connector: Connector,
    private http: HttpClient,
    private constants: Constants,
    @Inject(PLATFORM_ID) private platformId: string,
    private router: Router,
    private readonly seoService: SeoService,
    private userService: UserService
  ) {
    this.seoService.updateMetaInformation('calculadoras');
    if(isPlatformBrowser(this.platformId)){
      if (window.matchMedia && window.matchMedia('(prefers-color-scheme: dark)').matches) this.isDarkMode = true;
      else this.isDarkMode = false;  
    }
    else this.isDarkMode = false;
  }

  // Geral

  public cdiHoje: Number;
  public selicHoje: Number;
  public ipcaHoje: Number;
  public poupHoje: Number;
  public dataHoje: Date;
  public dataIni: Date;
  public windowWidth: number;
  public selectedIndex: number = 0;
  public isDarkMode: boolean = false;
  public campaignRef: string = "DI";

  // Calculadora do Tesouro Direto

  public titulosPublicos: TituloCard[];
  public tituloEscolhido;
  public tesouroValinv: Number = 0;
  public tesouroVendaToogle: Boolean = false;
  public tesouroAporte: Number = 0;
  public tesouroDataVenda: Date;
  public tesouroTaxaVenda: Number;
  public tesouroDataCompra: Date;
  public tesouroPrecoCompra: Number = 0;
  public tesouroTaxa: Number;
  public tesouroInflacao: Number;
  public tesouroSelic: Number;
  public isJurosSem: Boolean = true;
  public tituloPublico: TituloCard;
  public maxDataVenda: Date;

  // Calculadora do Cidadão

  public cidadaoSelec: number = 0;
  public cidadaoCalc: number = 0;
  public cidadaoValPret: number;
  public cidadaoValFin: number;
  public cidadaoJurosAM: number;
  public cidadaoTempo: number;
  public cidadaoValPres: number;
  public cidadaoValFut: number;
  public cidadaoValApo: number;
  public cidadaoValJur: number;
  public cidadaoValIni: number;
  public numberOfItems = 3;
  public calcularOptions = [
    {
      value: 0,
      desc: "Financiamento"
    },
    {
      value: 1,
      desc: "Aplicação Mensal"
    },
    {
      value: 2,
      desc: "Flexível"
    }
  ];
  public financiamentoOptions = [
    {
      value: 0,
      desc: "Valor do Financiamento"
    },
    {
      value: 1,
      desc: "Valor da Prestação"
    },
    {
      value: 2,
      desc: "Juros a.m."
    },
    {
      value: 3,
      desc: "Tempo"
    }
  ];
  public flexivelOptions = [
    {
      value: 4,
      desc: "Valor Futuro"
    },
    {
      value: 5,
      desc: "Valor Presente"
    },
    {
      value: 6,
      desc: "Valor do Aporte"
    },
    {
      value: 7,
      desc: "Juros"
    },
    {
      value: 8,
      desc: "Tempo"
    }
  ];
  public valCalOptions = this.financiamentoOptions;
  public screenWidth;

  // Calculadora do Milhão

  public milhaoValInv: Number;
  public milhaoApoMen: Number;
  public milhaoJur: Number;

  // Conversão de Taxas

  public convTaxa: Number;
  public convPeriodicidade: String;
  public convDias: String;

  // Calculadora de Taxas Equivalentes

  public equivTaxa: Number;
  public equivComIr: String;
  public equivSemIr: String;

  // Calculadora de Pré Vs. Pós

  public compPre: Number;
  public compPos: Number;

  // Calculadora do DI

  public diDataIni: Date;
  public diDataFim: Date;
  public diPorcent: Number; 
  public diVal: Number;
  public diInfo = [];
  public minDateDi = new Date(1987,0,1);
  public maxDateDi = new Date();
	public updateRentabilityFromInput = false;
  public oneToOne = false;
  public responseInsidePage = false;
  public noResults = false;
  private graphColors = ['#2f7ed8', '#0d233a', '#8bbc21', '#910000', '#1aadce',
  '#492970', '#f28f43', '#77a1e5', '#c42525', '#a6c96a'];
  private resultNames = ['RESULTADO 1', 'RESULTADO 2', 'RESULTADO 3', 'RESULTADO 4', 
  'RESULTADO 5', 'RESULTADO 6', 'RESULTADO 7', 'RESULTADO 8', 'RESULTADO 9', 'RESULTADO 10'];
	highcharts = Highcharts;
  rentabilityChartOptions = {
    legend: {itemStyle: {color: '#323232'}},
		chart: {
			backgroundColor: 'white'
		},
		title: {
      align: 'left',
			text: "Rentabilidade",
      style: {color: "black"},
      margin: 30
		},
		credits: {
			enabled: false
		},
		xAxis: {
			title: {
				text: ""
			},
      ordinal: true,
			labels: {
				style:{color: '#323232'},
				formatter: function() {
				  	return Highcharts.dateFormat('%d/%m/%Y', this.value);
				}
			}
		},
		yAxis: {
			title: {
				text: null
			},
			labels: {
				style:{color: '#323232'},
				formatter: function () {
          return 'R$ ' + Highcharts.numberFormat(this.value, 2, ',', '.');
				}
			},
		},
		tooltip: {
			formatter: function () {
				return this.points.reduce(function (s, point) {
					return  s + '<br/>' + '<span style="color: '+ point.color +';">\u25CF </span>' + point.series.name + ' : ' +
						'R$ ' + Highcharts.numberFormat(point.y, 2, ',', '.');
				}, '<b>' + Highcharts.dateFormat('%d/%m/%Y', this.x) + '</b>');
			},
			crosshairs: [true],
			shared: true
		},
		series: []
	};

  // Tela Renda Fixa

  public chosenRendaFixa;
  public RendaFixaValue1: Boolean;
  public RendaFixaValue2: Boolean;
  public RendaFixaValue3: Boolean;
  public RendaFixaValue4: Boolean;
  public RendaFixaValue5: Boolean;
  public RendaFixaValue6: Boolean;
  public RendaFixaValue7: Boolean;
  public RendaFixaValue8: Boolean;
  public RendaFixaValue9: Boolean;
  public RendaFixaValue10: Boolean;
  public RendaFixaValue11: Boolean;
  public RendaFixaValue12: Boolean;
  public RendaFixaDisabled1: Boolean = true;
  public RendaFixaDisabled2: Boolean = true;
  public RendaFixaDisabled3: Boolean = true;
  public RendaFixaDisabled4: Boolean = true;
  public RendaFixaDisabled5: Boolean = true;
  public RendaFixaDisabled6: Boolean = true;
  public RendaFixaDisabled7: Boolean = true;
  public RendaFixaDisabled8: Boolean = true;
  public RendaFixaDisabled9: Boolean = true;
  public RendaFixaDisabled10: Boolean = true;
  public RendaFixaDisabled11: Boolean = true;
  public RendaFixaDisabled12: Boolean = true;
  public selic: boolean;
  public ipca: boolean;
  public di: boolean;
  public all: boolean;
  public rfValinv: number;
  public rfPeriod: number;
  public rfPeriodSelect: number = 1;
  public rfDI: number;
  public rfIPCA: number;
  public rfSelic: number;
  public rfCdbPosCdi: number;
  public rfCdbPosIpca: number;
  public rfCdbPre: number;
  public rfLciPosCdi: number;
  public rfLciPosIpca: number;
  public rfLciPre: number;
  public rfTxAdm: number;
  public rfTesIpca: number;
  public rfTesPre: number;
  public rfPoup: number;

  public optionsRendaFixa = [
    {desc: 'Todos', value: 0},
    {desc: 'CDB ou LC pós-CDI', value: 1},
    {desc: 'CDB ou LC pós-IPCA', value: 2},
    {desc: 'CDB ou LC pré-fixado', value: 3},
    {desc: 'LCI ou LCA pós-CDI', value: 4},
    {desc: 'LCI ou LCA pós-IPCA', value: 5},
    {desc: 'LCI ou LCA pré-fixado', value: 6},
    {desc: 'Tesouro IPCA+ (NTN-B Princ.)', value: 7},
    {desc: 'Tesouro IPCA+ c/ Juros Semestrais (NTN-B Princ.)', value: 8},
    {desc: 'Tesouro pré-fixado (LTN)', value: 9},
    {desc: 'Tesouro pré-fixado c/ Juros Semestrais (LTN)', value: 10},
    {desc: 'Tesouro Selic (LFT)', value: 11},
    {desc: 'Poupança', value: 12},
  ]

  ngOnInit() {
    this.userService.checkUserCaptcha().then(()=>{
      this.indicatorsService.indicatorsObject.then(result => {
        this.cdiHoje = parseFloat(result['cdi'])/100;
        this.selicHoje = parseFloat(result['selic']);
        this.ipcaHoje = parseFloat(result['ipca_acu_12']);
        this.poupHoje = parseFloat(result['poup_acu_12']);
        this.equivTaxa = Number(this.cdiHoje)*100;
        this.rfDI = Number(this.cdiHoje)*100;
        this.rfSelic = Number(this.selicHoje);
        this.rfIPCA = Number(this.ipcaHoje);
        this.rfPoup = Number(this.poupHoje);
      });
    });
    this.investmentsService.investments("tesourodireto").then(result => {
      this.titulosPublicos = result;
    });

    let calcChosen = this.router.url.replace('/app/calculadoras/','');
    switch(calcChosen){
      case 'DI':
        this.selectedIndex = 0;
        this.campaignRef = 'DI';
        break;
      case 'tesourodireto':
        this.selectedIndex = 1;
        this.campaignRef = 'Tesouro Direto';
        break;
      case 'cidadao':
        this.selectedIndex = 2;
        this.campaignRef = 'Cidadão';
        break;
      case 'milhao':
        this.selectedIndex = 3;
        this.campaignRef = 'Milhão';
        break;
      case 'rendafixa':
        this.selectedIndex = 4;
        this.campaignRef = 'Renda Fixa';
        break;
      case 'prepos':
        this.selectedIndex = 5;
        this.campaignRef = 'Pré-pós';
        break;
      case 'taxasequivalentes':
        this.selectedIndex = 6;
        this.campaignRef = 'Equivalentes';
        break;
      case 'taxas':
        this.selectedIndex = 7;
        this.campaignRef = 'Conversão';
        break;
      default:
        this.selectedIndex = 0;
    }

    if(this.isDarkMode){
			this.rentabilityChartOptions.chart.backgroundColor = '#383836';
			this.rentabilityChartOptions.xAxis.labels.style.color = 'white';
			this.rentabilityChartOptions.yAxis.labels.style.color = 'white';
			this.rentabilityChartOptions.title.style.color = 'white';
      this.rentabilityChartOptions.legend.itemStyle.color = 'white';
    }
  }

  changePages(e){
    switch(e.index){
      case 0:
        this.location.replaceState('/app/calculadoras/di');
        this.campaignRef = 'DI';
        if(this.rentabilityChartOptions.series && this.rentabilityChartOptions.series.length < 1){
          this.responseInsidePage = false;
        } else {
          this.responseInsidePage = true;
        }
        break;
      case 1:
        this.location.replaceState('/app/calculadoras/tesourodireto');
        this.campaignRef = 'Tesouro Direto';
        this.responseInsidePage = false;
        break;
      case 2:
        this.location.replaceState('/app/calculadoras/cidadao');
        this.campaignRef = 'Cidadão';
        this.responseInsidePage = false;
        break;
      case 3:
        this.location.replaceState('/app/calculadoras/milhao');
        this.campaignRef = 'Milhão';
        this.responseInsidePage = false;
        break;
      case 4:
        this.location.replaceState('/app/calculadoras/rendafixa');
        this.campaignRef = 'Renda Fixa';
        this.responseInsidePage = false;
        break;
      case 5:
        this.location.replaceState('/app/calculadoras/prepos');
        this.campaignRef = 'Pré-pós';
        this.responseInsidePage = false;
        break;
      case 6:
        this.location.replaceState('/app/calculadoras/taxasequivalentes');
        this.campaignRef = 'Equivalentes';
        this.responseInsidePage = false;
        break;
      case 7:
        this.location.replaceState('/app/calculadoras/taxas');
        this.campaignRef = 'Conversão';
        this.responseInsidePage = false;
        break;
      default:
        this.responseInsidePage = false;
    }
  }

  onResize(event){
    this.windowWidth = event.target.innerWidth; // window width
  }

  isAll(val){
    if(val == 0 && !this.all){
      this.chosenRendaFixa = [0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12];
      this.all = !this.all;
    } else if( val == 0 && this.all){
      this.chosenRendaFixa = [];
      this.all = !this.all;
    } else if (val != 0 && this.all){
      this.chosenRendaFixa = this.chosenRendaFixa.splice(1,12);
      this.all = !this.all;
    } else if(val != 0 && !this.all && this.chosenRendaFixa.length == 12){
      this.chosenRendaFixa = [0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12];
      this.all = !this.all;
    }
    this.changeOptionRendaFixa();
  }

  changeOptionTesouro(escolha?){
    this.tesouroInflacao = undefined;
    this.tesouroSelic = undefined;
    this.tituloEscolhido = escolha;
    this.tesouroValinv = escolha['preco_compra'];
    this.tesouroDataVenda = escolha['dt_venda'];
    this.maxDataVenda = escolha['data_vencto'];
    this.tesouroTaxaVenda = escolha['taxa_venda'];
    this.tesouroDataCompra = new Date()
    this.tesouroPrecoCompra = escolha['preco_compra'];
    this.tesouroTaxa = escolha['taxa_compra'];
    this.dataHoje = new Date();
    this.dataIni =  escolha['dt_ini'];
    this.isJurosSem = escolha.jurosSemestrais;
    if(escolha.idx == 'ipca') this.tesouroInflacao = this.ipcaHoje;
    if(escolha.idx == 'selic') this.tesouroSelic = this.selicHoje;
  }

  changeOptionRendaFixa(){
    this.selic = this.chosenRendaFixa.includes(11);
    this.di = (this.chosenRendaFixa.includes(1) || this.chosenRendaFixa.includes(4));
    this.ipca = (this.chosenRendaFixa.includes(2) || this.chosenRendaFixa.includes(5) || this.chosenRendaFixa.includes(7) || this.chosenRendaFixa.includes(8));
    this.RendaFixaValue1 = this.chosenRendaFixa.includes(1); // CDB ou LC pós-CDI
    this.RendaFixaValue2 = this.chosenRendaFixa.includes(2); // CDB ou LC pós-IPCA
    this.RendaFixaValue3 = this.chosenRendaFixa.includes(3); // CDB ou LC pré-fixado
    this.RendaFixaValue4 = this.chosenRendaFixa.includes(4); // LCI ou LCA pós-CDI
    this.RendaFixaValue5 = this.chosenRendaFixa.includes(5); // LCI ou LCA pós-IPCA
    this.RendaFixaValue6 = this.chosenRendaFixa.includes(6); // LCI ou LCA pré-fixado
    this.RendaFixaValue7 = this.chosenRendaFixa.includes(7); // Tesouro IPCA+ (NTN-B Princ.)
    this.RendaFixaValue8 = this.chosenRendaFixa.includes(8); // Tesouro IPCA+ c/ juros (NTN-B Princ.)
    this.RendaFixaValue9 = this.chosenRendaFixa.includes(9); // Tesouro Pré-fixado (LTN)  
    this.RendaFixaValue10 = this.chosenRendaFixa.includes(10); // Tesouro Pré-fixado c/ juros (LTN) 
    this.RendaFixaValue11 = this.chosenRendaFixa.includes(11); // Tesouro Selic (LFT)
    this.RendaFixaValue12 = this.chosenRendaFixa.includes(12); // Poupança
  }

  changeSubOptionCidadao(){
    this.cidadaoValPret = undefined;
    this.cidadaoValFin = undefined;
    this.cidadaoJurosAM = undefined;
    this.cidadaoTempo = undefined;
    this.cidadaoValPres = undefined;
    this.cidadaoValFut = undefined;
    this.cidadaoValApo = undefined;
    this.cidadaoValJur = undefined;
    this.cidadaoValIni = undefined;
  }

  changeOptionCidadao(){
    this.cidadaoValPret = undefined;
    this.cidadaoValFin = undefined;
    this.cidadaoJurosAM = undefined;
    this.cidadaoTempo = undefined;
    this.cidadaoValPres = undefined;
    this.cidadaoValFut = undefined;
    this.cidadaoValApo = undefined;
    this.cidadaoValJur = undefined;
    this.cidadaoValIni = undefined;
    switch(this.cidadaoSelec){
      case 0:
        this.valCalOptions = this.financiamentoOptions;
        this.cidadaoCalc = 0;
        this.numberOfItems = 3;
        break;
      case 1:
        this.valCalOptions = [];
        this.cidadaoCalc = 9;
        this.numberOfItems = 4;
        break;
      case 2:
        this.valCalOptions = this.flexivelOptions;
        this.cidadaoCalc = 4;
        this.numberOfItems = 4;
        break;
    }
  }

  checkDisable(option){
    if(option == 'rendafixa'){
      if(!this.RendaFixaValue1 && !this.RendaFixaValue2 && !this.RendaFixaValue3 && !this.RendaFixaValue4 && !this.RendaFixaValue5 && !this.RendaFixaValue6 && !this.RendaFixaValue7 && !this.RendaFixaValue8 && !this.RendaFixaValue9 && !this.RendaFixaValue10 && !this.RendaFixaValue11 && !this.RendaFixaValue12) return true;
      this.RendaFixaDisabled1 = !this.RendaFixaValue1 ? false : (this.rfValinv && this.rfPeriod && this.rfDI && this.rfCdbPosCdi) ? false : true; // CDB ou LC pós-CDI
      this.RendaFixaDisabled2 = !this.RendaFixaValue2 ? false : (this.rfValinv && this.rfPeriod && this.rfIPCA && this.rfCdbPosIpca) ? false : true; // CDB ou LC pós-IPCA
      this.RendaFixaDisabled3 = !this.RendaFixaValue3 ? false : (this.rfValinv && this.rfPeriod && this.rfCdbPre) ? false : true; // CDB ou LC pré-fixado
      this.RendaFixaDisabled4 = !this.RendaFixaValue4 ? false : (this.rfValinv && this.rfPeriod && this.rfDI && this.rfLciPosCdi) ? false : true; // LCI ou LCA pós-CDI
      this.RendaFixaDisabled5 = !this.RendaFixaValue5 ? false : (this.rfValinv && this.rfPeriod && this.rfIPCA && this.rfLciPosIpca) ? false : true; // LCI ou LCA pós-IPCA
      this.RendaFixaDisabled6 = !this.RendaFixaValue6 ? false : (this.rfValinv && this.rfPeriod && this.rfLciPre) ? false : true; // LCI ou LCA pré-fixado
      this.RendaFixaDisabled7 = !this.RendaFixaValue7 ? false : (this.rfValinv && this.rfPeriod && this.rfIPCA && this.rfTesIpca) ? false : true; // Tesouro IPCA+ (NTN-B Princ.)
      this.RendaFixaDisabled8 = !this.RendaFixaValue8 ? false : (this.rfValinv && this.rfPeriod && this.rfIPCA && this.rfTesIpca) ? false : true; // Tesouro IPCA+ c/ juros (NTN-B Princ.)
      this.RendaFixaDisabled9 = !this.RendaFixaValue9 ? false : (this.rfValinv && this.rfPeriod && this.rfTesPre) ? false : true; // Tesouro Pré-fixado (LTN)  
      this.RendaFixaDisabled10 = !this.RendaFixaValue10 ? false : (this.rfValinv && this.rfPeriod && this.rfTesPre) ? false : true; // Tesouro Pré-fixado c/ juros (LTN) 
      this.RendaFixaDisabled11 = !this.RendaFixaValue11 ? false : (this.rfValinv && this.rfPeriod && this.rfSelic) ? false : true; // Tesouro Selic (LFT)
      this.RendaFixaDisabled12 = !this.RendaFixaValue12 ? false : (this.rfValinv && this.rfPeriod && this.rfPoup) ? false : true; // Poupança
      if(this.RendaFixaDisabled1 || this.RendaFixaDisabled2 || this.RendaFixaDisabled3 || this.RendaFixaDisabled4 || this.RendaFixaDisabled5 || this.RendaFixaDisabled6 || this.RendaFixaDisabled7 || this.RendaFixaDisabled8 || this.RendaFixaDisabled9 || this.RendaFixaDisabled10 || this.RendaFixaDisabled11 || this.RendaFixaDisabled12) return true;
      else return false;
    } 
    else if(option == 'cidadao'){
      switch(this.cidadaoCalc){
        case 0: // Valor do Financiamento
          if(!this.cidadaoValPret || !this.cidadaoJurosAM || !this.cidadaoTempo) return true;
          else return false;
        case 1: // Valor da Prestação
          if(!this.cidadaoValFin || !this.cidadaoJurosAM || !this.cidadaoTempo) return true;
          else return false;
        case 2: // Juros a.m.
          if(!this.cidadaoValPret || !this.cidadaoValFin || !this.cidadaoTempo || ((this.cidadaoValPret * this.cidadaoTempo) > this.cidadaoValFin)) return true;
          else return false;
        case 3: // Tempo
          if(!this.cidadaoValPret || !this.cidadaoJurosAM || !this.cidadaoValFin || this.cidadaoValFin <= this.cidadaoValPret) return true;
          else return false;
        case 4: // Valor Futuro - Flexível
          if(
            (!this.cidadaoValApo && !this.cidadaoValPres) || 
            !this.cidadaoTempo || 
            !this.cidadaoValJur
          ) return true;
          else {
            !this.cidadaoValPres ? this.cidadaoValPres = 0 : this.cidadaoValPres;
            !this.cidadaoValApo ? this.cidadaoValApo = 0 : this.cidadaoValApo;
            return false;
          }
        case 5: // Valor Presente - Flexível
          if(
            (!this.cidadaoValFut && !this.cidadaoValApo) || 
            !this.cidadaoTempo || 
            !this.cidadaoValJur ||
            (this.cidadaoValFut <= this.cidadaoValApo && this.cidadaoValFut != 0 && this.cidadaoValApo != 0)) return true;
          else {
            !this.cidadaoValFut ? this.cidadaoValFut = 0 : this.cidadaoValFut;
            !this.cidadaoValApo ? this.cidadaoValApo = 0 : this.cidadaoValApo;
            return false;
          }
        case 6: // Valor do Aporte - Flexível
          if(
            !this.cidadaoValFut ||
            !this.cidadaoTempo || 
            !this.cidadaoValJur ||
            (this.cidadaoValFut <= this.cidadaoValPres)) return true;
          else {
            !this.cidadaoValPres ? this.cidadaoValPres = 0 : this.cidadaoValPres;
            return false;
          }
        case 7: // Juros - Flexível
          if((!this.cidadaoValApo && !this.cidadaoValPres) ||
            !this.cidadaoTempo || 
            !this.cidadaoValFut ||
            (this.cidadaoValApo >= this.cidadaoValFut || this.cidadaoValPres >= this.cidadaoValFut)) return true;
          else {
            !this.cidadaoValPres ? this.cidadaoValPres = 0 : this.cidadaoValPres;
            !this.cidadaoValApo ? this.cidadaoValApo = 0 : this.cidadaoValApo;
            return false;
          }
        case 8: // Tempo - Flexível
        if((!this.cidadaoValApo && !this.cidadaoValPres) ||
        !this.cidadaoValJur || 
        !this.cidadaoValFut ||
        (this.cidadaoValApo >= this.cidadaoValFut || this.cidadaoValPres >= this.cidadaoValFut)) return true;
          else {
            !this.cidadaoValPres ? this.cidadaoValPres = 0 : this.cidadaoValPres;
            !this.cidadaoValApo ? this.cidadaoValApo = 0 : this.cidadaoValApo;
            return false;
          }
        case 9: // Aplicação Mensal
          if(!this.cidadaoValApo || !this.cidadaoTempo || !this.cidadaoJurosAM) return true;
          else {
            !this.cidadaoValIni ? this.cidadaoValIni = 0 : this.cidadaoValIni;
            return false;
          }
        default:
          return true;
      }
    }
    else if(option == 'tesouro'){
      if(!this.tituloPublico) return true;
      else if(!this.tesouroValinv) return true;
      else if(this.tesouroVendaToogle && (!this.tesouroDataVenda || !this.tesouroTaxaVenda)) return true;
      else if(this.tituloPublico.idx == 'pre' && !this.tesouroTaxa) return true;
      else if(this.tituloPublico.idx == 'ipca' && !this.tesouroInflacao) return true;
      else if(this.tituloPublico.idx == 'selic' && !this.tesouroSelic) return true;
      else if(!this.tesouroDataCompra || !this.tesouroTaxa) return true;
      else return false;
    }
  }

  createRendaFixaPayload(){
    let payload = {
      tipo_titulos: [],
      preco: JSON.stringify(this.rfValinv),
      dc: this.rfPeriodSelect == 1 ? JSON.stringify(this.rfPeriod) : JSON.stringify(this.rfPeriod*30),
      mes_selection: this.rfPeriodSelect == 1 ? "Dias" : "Meses",
      tx_adm: this.rfTxAdm == undefined ? "0" : JSON.stringify(this.rfTxAdm)
    }

    if(this.di) payload['cdi'] = JSON.stringify(this.rfDI);
    if(this.ipca) payload['ipca'] = JSON.stringify(this.rfIPCA);
    if(this.selic) payload['selic'] = JSON.stringify(this.rfSelic);

    if(this.RendaFixaValue1){
      payload['cdb_pos_cdi'] = JSON.stringify(this.rfCdbPosCdi);
      payload['tipo_titulos'].push('cdb-pos-cdi');
    }
    if(this.RendaFixaValue2){
      payload['cdb_pos_ipca'] = JSON.stringify(this.rfCdbPosIpca);
      payload['tipo_titulos'].push('cdb-pos-ipca');
    }
    if(this.RendaFixaValue3){
      payload['cdb_pre'] = JSON.stringify(this.rfCdbPre);
      payload['tipo_titulos'].push('cdb-pre');
    }
    if(this.RendaFixaValue4){
      payload['lci_pos_cdi'] = JSON.stringify(this.rfLciPosCdi);
      payload['tipo_titulos'].push('lci-pos-cdi');
    }
    if(this.RendaFixaValue5){
      payload['lci_pos_ipca'] = JSON.stringify(this.rfLciPosIpca);
      payload['tipo_titulos'].push('lci-pos-ipca');
    }
    if(this.RendaFixaValue6){
      payload['lci_pre'] = JSON.stringify(this.rfLciPre);
      payload['tipo_titulos'].push('lci-pre');
    }
    if(this.RendaFixaValue7 || this.RendaFixaValue8){
      payload['td_ipca'] = JSON.stringify(this.rfTesIpca);
      if(this.RendaFixaValue7) payload['tipo_titulos'].push('td-ipca');
      if(this.RendaFixaValue8) payload['tipo_titulos'].push('td-ipca-jur');
    }
    if(this.RendaFixaValue9 || this.RendaFixaValue10){
      payload['td_pre'] = JSON.stringify(this.rfTesPre);
      if(this.RendaFixaValue7) payload['tipo_titulos'].push('td-pre');
      if(this.RendaFixaValue8) payload['tipo_titulos'].push('td-pre-jur');
    }
    if(this.RendaFixaValue11){
      payload['tipo_titulos'].push('td-selic');
    }
    if(this.RendaFixaValue12){
      payload['poupanca'] = JSON.stringify(this.rfPoup);
      payload['tipo_titulos'].push('poupanca');
    }
    return payload;
  }

  createCidadaoPayload(){
    let payload = {
      'code': this.cidadaoCalc
    };
    switch(this.cidadaoCalc){
      case 0: // Valor do Financiamento
        payload['aporte'] = this.cidadaoValPret;
        payload['fv'] = null;
        payload['juros'] = this.cidadaoJurosAM;
        payload['meses'] = this.cidadaoTempo;
        payload['pv'] = 0;
        return payload;
      case 1: // Valor da Prestação
        payload['aporte'] = null;
        payload['fv'] = this.cidadaoValFin;
        payload['juros'] = this.cidadaoJurosAM;
        payload['meses'] = this.cidadaoTempo;
        payload['pv'] = 0;
        return payload;
      case 2: // Juros a.m.
        payload['aporte'] = this.cidadaoValPret;
        payload['fv'] = this.cidadaoValFin;
        payload['juros'] = null;
        payload['meses'] = this.cidadaoTempo;
        payload['pv'] = 0;
        return payload;
      case 3: // Tempo
        payload['aporte'] = this.cidadaoValPret;
        payload['fv'] = this.cidadaoValFin;
        payload['juros'] = this.cidadaoJurosAM;;
        payload['meses'] = null;
        payload['pv'] = 0;
        return payload;
      case 4: // Valor Futuro
        payload['aporte'] = this.cidadaoValApo;
        payload['fv'] = null;
        payload['juros'] = this.cidadaoValJur;;
        payload['meses'] = this.cidadaoTempo;
        payload['pv'] = this.cidadaoValPres;
        return payload;
      case 5: // Valor Presente
        payload['aporte'] = this.cidadaoValApo;
        payload['fv'] = this.cidadaoValFut;
        payload['juros'] = this.cidadaoValJur;
        payload['meses'] = this.cidadaoTempo;
        payload['pv'] = null;
        return payload;
      case 6: // Valor do Aporte
        payload['aporte'] = null;
        payload['fv'] = this.cidadaoValFut;
        payload['juros'] = this.cidadaoValJur;
        payload['meses'] = this.cidadaoTempo;
        payload['pv'] = this.cidadaoValPres;
        return payload;
      case 7: // Juros
        payload['aporte'] = this.cidadaoValApo;
        payload['fv'] = this.cidadaoValFut;
        payload['juros'] = null;
        payload['meses'] = this.cidadaoTempo;
        payload['pv'] = this.cidadaoValPres;
        return payload;
      case 8: // Tempo
        payload['aporte'] = this.cidadaoValApo;
        payload['fv'] = this.cidadaoValFut;
        payload['juros'] = this.cidadaoValJur;
        payload['meses'] = null;
        payload['pv'] = this.cidadaoValPres;
        return payload;
      case 9: // Aplicação Mensal
        payload['aporte'] = this.cidadaoValApo;
        payload['fv'] = null;
        payload['juros'] = this.cidadaoJurosAM;
        payload['meses'] = this.cidadaoTempo;
        payload['pv'] = this.cidadaoValIni
        return payload;
      default:
        return true;
    }
  }

  calc(choice?) {
    this.spinner.show();
    if(choice == 'rendafixa'){
      let payload = this.createRendaFixaPayload();
      this.calculatorService.calcComparador(payload).then(response => {
        this.spinner.hide();
        const dialogRef = this.dialog.open(ResultadoPopUpComponent, {
          data: {
            result: response,
            initial_info: payload,
            type: 'rendafixa',
            darkMode: this.isDarkMode
          },
          disableClose: false,
          closeOnNavigation: true,
        }).afterClosed().subscribe(result => {
          if(result) this.clear(result);
        });
      }).catch(err => {
        this.spinner.hide("Ocorreu um error em nosso servidor", "Ok");
      });
    }
    else if(choice == 'equiv'){
      let payload = {
        cdi: this.equivTaxa,
        cir: this.equivComIr,
        sir: this.equivSemIr
      }
      this.calculatorService.calcEquivalencia(payload).then(response => {
        this.spinner.hide();
        const dialogRef = this.dialog.open(ResultadoPopUpComponent, {
          data: {
            result: response,
            initial_info: payload,
            type: 'equiv',
            darkMode: this.isDarkMode
          },
          disableClose: false,
          closeOnNavigation: true,
        }).afterClosed().subscribe(result => {
          if(result) this.clear(result);
        });
      }).catch(err => {
        this.spinner.hide("Ocorreu um problema em nosso servidor", "Ok");
      });
    }
    else if(choice == 'conversao'){
      let payload = {
        taxa: this.convTaxa,
        dc: this.convDias,
        periodicidade: this.convPeriodicidade
      }
      this.calculatorService.calcTaxas(payload).then(response => {
        this.spinner.hide();
        const dialogRef = this.dialog.open(ResultadoPopUpComponent, {
          data: {
            result: response,
            initial_info: payload,
            type: 'conversao',
            darkMode: this.isDarkMode
          },
          disableClose: false,
          closeOnNavigation: true,
        }).afterClosed().subscribe(result => {
          if(result) this.clear(result);
        });
      }).catch(err => {
        this.spinner.hide("Ocorreu um problema em nosso servidor", "Ok");
      });
    }
    else if(choice == 'prepos'){
      let payload = {
        idx: 0,
        pos: this.compPos,
        pre: this.compPre,
        cdi_hoje: this.cdiHoje
      }
      this.calculatorService.calcPrePos(payload).then(response => {
        this.spinner.hide();
        const dialogRef = this.dialog.open(ResultadoPopUpComponent, {
          data: {
            result: response,
            initial_info: payload,
            type: 'prepos',
            darkMode: this.isDarkMode
          },
          disableClose: false,
          closeOnNavigation: true,
        }).afterClosed().subscribe(result => {
          if(result) this.clear(result);
        });
      }).catch(err => {
        this.spinner.hide("Ocorreu um problema em nosso servidor", "Ok");
      });
    }
    else if(choice == 'milhao'){
      let payload = {
        pv: this.milhaoValInv,
        aporte: this.milhaoApoMen,
        juros: this.milhaoJur,
        fv: 1000000
      }
      this.calculatorService.calcAplicacao(payload).then(response => {
        this.spinner.hide();
        const dialogRef = this.dialog.open(ResultadoPopUpComponent, {
          data: {
            result: response,
            initial_info: payload,
            type: 'milhao',
            darkMode: this.isDarkMode
          },
          disableClose: false,
          closeOnNavigation: true,
        }).afterClosed().subscribe(result => {
          if(result) this.clear(result);
        });
      }).catch(err => {
        this.spinner.hide("Ocorreu um problema em nosso servidor", "Ok");
      });
    }
    else if(choice == 'cidadao'){
      let payload = this.createCidadaoPayload();
      this.calculatorService.calcAplicacao(payload).then(response => {
        this.spinner.hide();
        const dialogRef = this.dialog.open(ResultadoPopUpComponent, {
          data: {
            result: response,
            initial_info: payload,
            type: 'cidadao',
            darkMode: this.isDarkMode
          },
          disableClose: false,
          closeOnNavigation: true,
        }).afterClosed().subscribe(result => {
          if(result) this.clear(result);
        });
      }).catch(err => {
        this.spinner.hide("Ocorreu um problema em nosso servidor", "Ok");
      });
    }
    else if(choice == 'tesouro'){
      let payload = {
        dt_compra: isDate(this.tesouroDataCompra) ? this.datepipe.transform(this.tesouroDataCompra, 'dd/MM/yyyy') : this.tesouroDataCompra,
        dt_vencto: this.maxDataVenda,
        dt_venda: isDate(this.tesouroDataVenda) ? this.datepipe.transform(this.tesouroDataVenda, 'dd/MM/yyyy') : this.tesouroDataVenda,
        id_titulo: Number(this.tituloPublico._id) || this.tituloPublico.id_titulo,
        indexador: this.tituloPublico.idx == 'pre' ? JSON.stringify(this.tesouroTaxa) : this.tituloPublico.idx == 'ipca' ? JSON.stringify(this.ipcaHoje) : JSON.stringify(this.selicHoje),
        ipca: JSON.stringify(this.ipcaHoje),
        selic: JSON.stringify(this.selicHoje),
        juros: "undefined",
        lastro: true,
        nom: this.tituloPublico.nome,
        nome: "Tesouro " + this.tituloPublico.nome,
        p: JSON.stringify(Number(this.tesouroValinv)),
        preco_compra: JSON.stringify(Number(this.tesouroPrecoCompra)),
        preco_venda: JSON.stringify(Number(this.tituloPublico.precoVenda)),
        qtd: JSON.stringify((Number(this.tesouroPrecoCompra)/this.tituloPublico.pu)),
        rbalm: this.tituloPublico.rentAno,
        rlalm: this.tituloPublico.rentLiqAno,
        taxa_adm: 0,
        taxa_compra: JSON.stringify(Number(this.tesouroTaxa)),
        taxa_venda: JSON.stringify(Number(this.tesouroTaxaVenda)),
        valor_aporte: this.tesouroAporte,
        tipo: this.tituloPublico.nome
      }
      this.calculatorService.calcTD(payload).then(response => {
        this.spinner.hide();
        const dialogRef = this.dialog.open(ResultadoPopUpComponent, {
          maxWidth: this.windowWidth == 600 ? 'auto' : '80vw',
          width: this.windowWidth == 600 ? '90%' : 'auto',
          data: {
            result: response,
            type: 'tesouro',
            darkMode: this.isDarkMode
          },
          disableClose: false,
          closeOnNavigation: true,
        }).afterClosed().subscribe(result => {
          if(result) this.clear(result);
        });
      }).catch(err => {
        this.spinner.hide("Ocorreu um error em nosso servidor", "Ok");
      });
    } 
    else if(choice == 'DI'){
      let payload = {
        "data_ini":  this.datepipe.transform(this.diDataIni, 'dd/MM/yyyy'),
        "data_fim":  this.datepipe.transform(this.diDataFim, 'dd/MM/yyyy'),
        "percentual":  this.diPorcent,
        "valor": this.diVal
      }

      /* A chamada do endpoint abaixo ser diferente das outras formas (com o calcDI() no calculator.service.ts) é em virtude de um 
      bug com chamadas sequenciais de curto intervalo. O bug em questão tem o seguinte comportamento: Ele realiza a ação 
      selecionada, usa a resposta do http request anterior e gera o resultado. Esse comportamento é identificável se: Não aparecer o 
      spinner e não aparecer o request na aba "network" na ferramenta de desenvolvedor, mas concluir a operação. */

      this.http.post(this.constants.get('calcDI'), payload).toPromise()
      .then(response => {
        const responseJsonified = response;
        if(responseJsonified && responseJsonified['msg']) {
          this.spinner.hide(responseJsonified['msg']);
          this.noResults = true;
        }
        else this.noResults = false;
        const selectedColor = this.graphColors.shift();
        const selectedName = this.resultNames.shift();

        let createArrayOfData = [];

        for(let a = 0; a < responseJsonified['grafico_datas'].length; a++){
					createArrayOfData.push([responseJsonified['grafico_datas'][a],responseJsonified['grafico_valores'][a]]);
				}

        this.diInfo.unshift({
          'name': selectedName,
					'showInLegend': false,
					'color': selectedColor,
          'dataInicial': responseJsonified['data_inicial'],
          'dataFinal': responseJsonified['data_final'],
          'porcentual': responseJsonified['percentual'],
          'fator': responseJsonified['fator'],
          'taxa': responseJsonified['taxa'],
          'valorBase': responseJsonified['valor_base'],
          'valorCalc': responseJsonified['valor_calculado'],
          'valorLiq': responseJsonified['valor_liquido']
        })

        this.rentabilityChartOptions.series.push({
          'name': selectedName,
          'id': selectedName,
					'color': selectedColor,
					'data': createArrayOfData,
				});

        this.responseInsidePage = true;
        this.oneToOne = true;
        this.updateRentabilityFromInput = true;
        this.spinner.hide();
      });
    }
  }

  removeSimulation(nameToBeSearched){
    const indexGrafico = this.rentabilityChartOptions.series.findIndex( e => {
      return e.id == nameToBeSearched;
    });
    const indexInfo = this.diInfo.findIndex( e => {
      return e.name == nameToBeSearched;
    });
    if(indexGrafico < 0 || indexInfo < 0) return;
    this.graphColors.unshift(this.diInfo[indexInfo]['color']);
    this.resultNames.unshift(this.diInfo[indexInfo]['name']);
    this.diInfo.splice(indexInfo, 1);
    this.rentabilityChartOptions.series.splice(indexGrafico, 1);
    this.oneToOne = true;
    this.updateRentabilityFromInput = true;
    if(this.rentabilityChartOptions.series && this.rentabilityChartOptions.series.length < 1) this.responseInsidePage = false;  
  }

  clear(choice?){
    if(choice == 'conversao'){
      this.convDias = undefined;
      this.convPeriodicidade = undefined;
      this.convTaxa = undefined;
    } else if(choice == 'tesouro'){
      this.tituloPublico = undefined;
      this.tesouroValinv = undefined;
      this.tesouroVendaToogle = false;
      this.tesouroAporte = 0;
      this.tesouroDataVenda = undefined;
      this.tesouroTaxaVenda = 0;
      this.tesouroDataCompra = undefined;
      this.tesouroPrecoCompra = 0;
      this.tesouroTaxa = 0;
      this.tesouroInflacao = undefined;
      this.tesouroSelic = undefined;
      this.isJurosSem = false;
    } else if(choice == 'cidadao'){
      this.cidadaoSelec = 0;
      this.cidadaoCalc = 0;
      this.cidadaoValPret = undefined;
      this.cidadaoValFin = undefined;
      this.cidadaoJurosAM = undefined;
      this.cidadaoTempo = undefined;
      this.cidadaoValPres = undefined;
      this.cidadaoValFut = undefined;
      this.cidadaoValApo = undefined;
      this.cidadaoValJur = undefined;
      this.cidadaoValIni = undefined;
      this.numberOfItems = 3;
      this.valCalOptions = this.financiamentoOptions;
    } else if(choice == 'milhao'){
      this.milhaoValInv = undefined;
      this.milhaoApoMen = undefined;
      this.milhaoJur = undefined;
    } else if(choice == 'prepos'){
      this.compPre = undefined;
      this.compPos = undefined;
    } else if(choice == 'rendafixa'){
      this.chosenRendaFixa = undefined;
      this.RendaFixaValue1 = undefined;
      this.RendaFixaValue2 = undefined;
      this.RendaFixaValue3 = undefined;
      this.RendaFixaValue4 = undefined;
      this.RendaFixaValue5 = undefined;
      this.RendaFixaValue6 = undefined;
      this.RendaFixaValue7 = undefined;
      this.RendaFixaValue8 = undefined;
      this.RendaFixaValue9 = undefined;
      this.RendaFixaValue10 = undefined;
      this.RendaFixaValue11 = undefined;
      this.RendaFixaValue12 = undefined;
      this.RendaFixaDisabled1 = true;
      this.RendaFixaDisabled2 = true;
      this.RendaFixaDisabled3 = true;
      this.RendaFixaDisabled4 = true;
      this.RendaFixaDisabled5 = true;
      this.RendaFixaDisabled6 = true;
      this.RendaFixaDisabled7 = true;
      this.RendaFixaDisabled8 = true;
      this.RendaFixaDisabled9 = true;
      this.RendaFixaDisabled10 = true;
      this.RendaFixaDisabled11 = true;
      this.RendaFixaDisabled12 = true;
      this.selic = undefined;
      this.ipca = undefined;
      this.di = undefined;
      this.all = undefined;
      this.rfValinv = undefined;
      this.rfPeriod = undefined;
      this.rfPeriodSelect = 1;
      this.rfDI = Number(this.cdiHoje)*100;
      this.rfIPCA = Number(this.ipcaHoje);
      this.rfSelic = Number(this.selicHoje);
      this.rfCdbPosCdi = undefined;
      this.rfCdbPosIpca = undefined;
      this.rfCdbPre = undefined;
      this.rfLciPosCdi = undefined;
      this.rfLciPosIpca = undefined;
      this.rfLciPre = undefined;
      this.rfTxAdm = undefined;
      this.rfTesIpca = undefined;
      this.rfTesPre = undefined;
      this.rfPoup = Number(this.poupHoje);
    } else if(choice == 'equiv'){
      this.equivTaxa = undefined;
      this.equivComIr = undefined;
      this.equivSemIr = undefined;
    } else if(choice == 'curso-tesouro'){
        const tesouro = "https://loja.apprendafixa.com.br/loja/sample-product/tesouro-direto-ferramentas-combo-carteira-de-investimentos-tesouro-direto-ferramentas/";
        this.connector.openInNewTab(tesouro);
    } else if(choice == 'DI'){
      this.diDataIni = undefined;
      this.diDataFim = undefined;
      this.diPorcent = undefined;
      this.diVal = undefined;
    }
  } 
}
